import styled from 'styled-components';

export const Spacer = styled.div`
  margin-top: ${props => props.margin}rem;
`;